import axios from "@/plugins/axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      tKey: "dashboard.",
      loading: true,
      params: null,
      kpiData: null,
      kpiChartData: null,
      kpiChartEvo: null,
      provenancesData: null,
      destinationsData: null,
      starsChart: {
        options: {
          chart: {
            id: "hesta_stars",
          },
          xaxis: {
            categories: [],
            title: {
              text: this.$t("general.overnights"),
            },
            labels: {
              formatter: function(value) {
                return value.toLocaleString("de-CH");
              },
            },
          },
          plotOptions: {
            bar: {
              dataLabels: {
                position: "top",
              },
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: true,
            position: "right",
            offsetX: 45,
            style: {
              fontSize: "12px",
              colors: ["#000"],
            },
            formatter: function(value) {
              return value.toLocaleString("de-CH");
            },
          },
          colors: ["#0984e3", "#c5eff7"],
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
          },
        },
        type: "bar",
        data: [
          {
            name: this.$t("dashboard.kpi.overnights.header"),
            data: null,
          },
        ],
      },
      swissCities: {
        options: {
          chart: {
            id: "hestaSwissCities",
          },
          xaxis: {
            categories: [],
            title: {
              text: this.$t("legends.evoPercent"),
            },
            labels: {
              formatter: function(value) {
                return value.toLocaleString("de-CH", {
                  style: "percent",
                  maximumFractionDigits: 2,
                });
              },
            },
          },
          plotOptions: {
            bar: {
              dataLabels: {
                position: "top", // top, center, bottom
              },
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: true,
            offsetX: 35,
            style: {
              colors: ["#000"],
              fontSize: ".7rem",
            },
            formatter: function(value) {
              return value.toLocaleString("de-CH", {
                style: "percent",
                maximumFractionDigits: 2,
              });
            },
          },
          colors: ["#0984e3", "#c5eff7"],
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
          },
          tooltip: {
            y: {
              formatter: (value) => {
                return value.toLocaleString("de-CH", {
                  style: "percent",
                  maximumFractionDigits: 2,
                });
              },
            },
          },
        },
        type: "bar",
        data: [
          {
            name: this.$t("dashboard.kpi.overnights.header"),
            data: null,
          },
        ],
      },
      competitors_table: null,
      competitors_header: [
        { key: "competitor", label: this.$t("dashboard.competitors.city") },
        {
          key: "overnights",
          label: this.$t("dashboard.kpi.overnights.header"),
        },
        { key: "evolution", label: this.$t("dashboard.kpi.evolutionPercent") },
      ],
      recapTable: {
        data: null,
        header: [
          {
            key: "competitor",
            label: this.$t("dashboard.competitors.competitor"),
          },
          {
            key: "overnights",
            label: this.$t("dashboard.kpi.overnights.header"),
            sortable: true,
          },
          {
            key: "arrivals",
            label: this.$t("dashboard.kpi.arrivals.header"),
            sortable: true,
          },
          {
            key: "lOfStay",
            label: this.$t("dashboard.kpi.stay.header"),
            sortable: true,
          },
          {
            key: "evolution",
            label: this.$t("legends.evoPercent"),
            sortable: true,
          },
          {
            key: "evolution_real",
            label: this.$t("legends.evoReal"),
            sortable: true,
          },
          {
            key: "occupation",
            label: this.$t("dashboard.kpi.occupation.header"),
            sortable: true,
          },
        ],
        json_fields: null,
      },
      evolutionChart: {
        options: {
          plotOptions: {
            bar: {
              dataLabels: {
                position: "top", // top, center, bottom
              },
            },
          },
          chart: {
            id: "benchmark12Months",
          },
          xaxis: {
            categories: [],
            labels: {
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: false,
            },
          },
          yaxis: [
            {
              seriesName: "mycompany",
              title: {
                text: this.$t("legends.overnights"),
              },
            },
            {
              seriesName: "mycompany",
            },
            {
              seriesName: "competitor",
              opposite: true,
              title: {
                text: "Benchmark: " + this.$t("legends.overnights"),
              },
            },
          ],
          dataLabels: {
            enabledOnSeries: [0],
            offsetY: -15,
            style: {
              colors: ["#000"],
              fontSize: ".7rem",
            },
            formatter: function(val) {
              return val > 0 ? val.toLocaleString("fr-CH") : "0";
            },
          },
          colors: ["#0984e3", "#c5eff7", "#e74c3c"],
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
          },
        },
        type: "bar",
        data: [
          {
            name: this.$t("legends.actualYear"),
            data: null,
          },
          {
            name: this.$t("legends.previousYear"),
            data: null,
          },
          {
            name: "Benchmark",
            data: null,
          },
        ],
      },
      overYearChart: {
        options: {
          chart: {
            id: "benchmarkOveryear",
          },
          xaxis: {
            categories: null,
          },
          yaxis: {
            labels: {
              formatter: function(value) {
                return value.toLocaleString("fr-CH", {
                  style: "percent",
                  maximumFractionDigits: 2,
                });
              },
            },
            title: {
              text: this.$t("legends.evoPercent"),
            },
          },
          plotOptions: {
            bar: {
              dataLabels: {
                position: "top", // top, center, bottom
              },
            },
          },
          dataLabels: {
            enabledOnSeries: [0, 1],
            offsetY: -15,
            style: {
              colors: ["#000"],
              fontSize: ".6rem",
            },
            formatter: function(val) {
              return val.toLocaleString("fr-CH", {
                style: "percent",
                maximumFractionDigits: 2,
              });
            },
          },
          colors: ["red", "#e74c3c"],
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
          },
        },
        type: "bar",
        data: [
          {
            name: this.$t("legends.evolution"),
            data: null,
          },
          {
            name: "Benchmark",
            data: null,
          },
        ],
      },
      provenanceCard: {
        title: this.$t("dashboard.provenance.header"),
        header: [
          { key: "market", label: this.$t("dashboard.provenance.countries") },
          { key: "overnights", label: this.$t("hesta.overnights") },
          { key: "benchOvernights", label: this.$t("hesta.overnights") },
          { key: "evolution", label: this.$t("hesta.evolutionPercent") },
          { key: "benchEvolution", label: this.$t("hesta.evolutionPercent") },
          { key: "evolution_real", label: this.$t("hesta.evolution_real") },
          {
            key: "benchEvolution_real",
            label: this.$t("hesta.evolution_real"),
          },
          { key: "marketShare", label: this.$t("hesta.marketShare") },
          { key: "benchMarketShare", label: this.$t("hesta.marketShare") },
        ],
        content: null,
      },
    };
  },
  methods: {
    cleanVariables() {
      (this.kpiData = [
        {
          key: "overnights",
          data: null,
        },
        {
          key: "arrivals",
          data: null,
        },
        {
          key: "stay",
          data: null,
        },
        {
          key: "occupation",
          data: null,
        },
      ]),
        (this.provenancesData = null);
      this.destinationsData = null;
      this.competitors_table = null;
      this.swissCities.data[0].data = null;
      this.swissCities.options.xaxis.categories = null;
    },
    refreshData() {
      this.loading = true;
      this.cleanVariables();
      Promise.all([
        this.getPeriodOvernights(),
        this.getPeriodArrivals(),
        this.getPeriodStay(),
        this.getPeriodOccupationRate(),
        this.getPeriodMarkets(),
        this.getPeriodDestinations(),
        this.getMainRegionStarsNights(),
        this.getCompetitorsTable(),
      ])
        .then((res) => {
          (this.kpiData = [
            {
              key: "overnights",
              data: res[0].data,
            },
            {
              key: "arrivals",
              data: res[1].data,
            },
            {
              key: "stay",
              data: res[2].data,
            },
            {
              key: "occupation",
              data: res[3].data,
            },
          ]),
            (this.provenancesData = res[4].data);
          this.destinationsData = res[5].data;
        })
        .finally(() => {
          this.loading = false;
          this.updateKpiChart();
        });
    },
    refreshMarkets() {
      this.loading = true;
      this.resetMarkets();
      Promise.all([this.getMarketsDetails()]).finally(() => {
        this.loading = false;
      });
    },
    refreshFactsheet() {
      this.loading = true;
      this.resetFactsheet();
      Promise.all([
        this.getFactsheetsData(),
        this.getFactsheetsGData(),
      ]).finally(() => {
        this.loading = false;
      });
    },
    refreshBenchmark() {
      this.loading = true;
      this.resetBenchmark();
      Promise.all([
        this.getCompetitorsFullTable(),
        this.getEvo12Months(
          this.params.competitor ? this.params.competitor : 0
        ),
        this.getCompetitorsProvenances(),
      ]).finally(() => {
        this.loading = false;
      });
    },
    resetFactsheet() {
      this.factsheetChart.data[0].data = null;
      this.factsheetChart.data[1].data = null;
      this.factsheetChart.options.xaxis.categories = null;
      this.gchart.data = null;
    },
    resetMarkets() {
      this.marketsTable.data = null;
    },
    resetBenchmark() {
      this.recapTable.data = null;
      this.provenanceCard.content = null;
      this.evolutionChart.options.xaxis.categories = null;
      this.evolutionChart.data[0].data = null;
      this.evolutionChart.data[1].data = null;
      this.overYearChart.options.xaxis.categories = null;
      this.overYearChart.data[0].data = null;
      this.evolutionChart.data[2].data = null;
      this.overYearChart.data[1].data = null;
    },
    getPeriodOvernights() {
      return axios.post("hesta/periodRecap", {
        monthMin: this.params.monthrange[0],
        monthMax: this.params.monthrange[1],
        regions: this.params.region.map((r) => r.value),
        fsmarket: this.params.markets.Value,
        comparisonYear: this.params.comparisonYear,
      });
    },
    getPeriodArrivals() {
      return axios.post("hesta/GetArrivalsRecap", {
        monthMin: this.params.monthrange[0],
        monthMax: this.params.monthrange[1],
        regions: this.params.region.map((r) => r.value),
        fsmarket: this.params.markets.Value,
        comparisonYear: this.params.comparisonYear,
      });
    },
    getPeriodStay() {
      return axios.post("hesta/GetLOfStayRecap", {
        monthMin: this.params.monthrange[0],
        monthMax: this.params.monthrange[1],
        regions: this.params.region.map((r) => r.value),
        fsmarket: this.params.markets.Value,
        comparisonYear: this.params.comparisonYear,
      });
    },
    getPeriodOccupationRate() {
      return axios.post("hesta/hestaOccupation", {
        monthMin: this.params.monthrange[0],
        monthMax: this.params.monthrange[1],
        regions: this.params.region.map((r) => r.value),
        fsmarket: this.params.markets.Value,
        comparisonYear: this.params.comparisonYear,
      });
    },
    getPeriodMarkets() {
      return axios.post("hesta/GetMainProvenances", {
        monthMin: this.params.monthrange[0],
        monthMax: this.params.monthrange[1],
        regions: this.params.region.map((r) => r.value),
        top: 20,
        language: this.$i18n.locale,
        fsmarket: this.params.markets.Value,
        comparisonYear: this.params.comparisonYear,
      });
    },
    getPeriodDestinations() {
      return axios.post("hesta/getPeriodDestinations", {
        monthMin: this.params.monthrange[0],
        monthMax: this.params.monthrange[1],
        ...this.$utils.getDestinationParams(),
        fsmarket: this.params.markets.Value,
        comparisonYear: this.params.comparisonYear,
        language: this.$i18n.locale,
      });
    },
    updateKpiChart(key = "overnights", cumul = false) {
      this.kpiChartData = null;
      let url;
      switch (key) {
        case "overnights":
          url = "periodPerMonth";
          break;
        case "arrivals":
          url = "GetArrivalsPerMonth";
          break;
        case "stay":
          url = "GetLOfStayPerMonth";
          break;
        case "occupation":
          url = "GetOccupationPerMonth";
          break;
        default:
          url = "periodPerMonth";
          break;
      }
      axios
        .post(`hesta/${url}`, {
          monthMin: this.params.monthrange[0],
          monthMax: this.params.monthrange[1],
          regions: this.params.region.map((r) => r.value),
          fsmarket: this.params.markets.Value,
          comparisonYear: this.params.comparisonYear,
        })
        .then((res) => {
          let evoPeriod = new Array();
          let actData = new Array();
          let prevData = new Array();
          let cumulAct = 0;
          let cumulPrev = 0;
          for (var i = 0; i < res.data[0].length; i++) {
            let contentAct = {
              year: res.data[0][i].year,
              month: res.data[0][i].month,
              sum: cumulAct + res.data[0][i].sum,
            };
            let contentPrev = {
              year: res.data[1][i].year,
              month: res.data[1][i].month,
              sum: cumulPrev + res.data[1][i].sum,
            };
            let contentEvo = {
              year: res.data[0][i].year,
              month: res.data[0][i].month,
              evo:
                (cumulAct + res.data[0][i].sum) /
                  (cumulPrev + res.data[1][i].sum) -
                1,
            };

            // add contents to arrays
            actData.push(contentAct);
            prevData.push(contentPrev);
            evoPeriod.push(contentEvo);

            // compute cumul if necessary
            if (cumul) {
              cumulAct += res.data[0][i].sum;
              cumulPrev += res.data[1][i].sum;
            }
          }

          this.kpiChartEvo = evoPeriod;
          this.kpiChartData = [actData, prevData];
        });
    },
    getMainRegionStarsNights() {
      axios
        .post("hesta/getPeriodByStars", {
          monthMin: this.params.monthrange[0],
          monthMax: this.params.monthrange[1],
          regions: this.params.region.map((r) => r.value),//[95], // force param for main regio in ZH
          language: this.$i18n.locale,
          fsmarket: this.params.markets.Value,
        })
        .then((res) => {
          
          const isMainRegion = this.params.region.map((r) => r.value).includes(95)|| this.params.region.length == 10;
          let header = new Array();
          let starsData = new Array();

          res.data.forEach((element) => {
            header.push(element.stars);
            if(isMainRegion){
            starsData.push(
              element.overnights == -1
                ? this.$t("general.dataProtection")
                : element.overnights
            );
          } else {
            starsData.push(0);
          }
          });

          // send data to component
          this.starsChart.options.xaxis.categories = header;
          this.starsChart.data[0].data = starsData;
        });
    },
    getCompetitorsTable() {
      axios
        .post("hesta/GetCompetitorsTable", {
          monthMin: this.params.monthrange[0],
          monthMax: this.params.monthrange[1],
          regions: [101], // force param for Zürich city
          language: this.$i18n.locale,
          fsmarket: this.params.markets.Value,
          comparisonYear: this.params.comparisonYear,
        })
        .then((res) => {
          let competitors = new Array();
          let citiesGraphValues = new Array();
          let citiesGraphLabels = new Array();

          // read dictionnary
          for (const [key, value] of Object.entries(res.data)) {
            let overnights = value.overnights;
            let overnightsPrev = value.overnightsPrev;
            let overnightsEvo = overnights / overnightsPrev - 1;
            var content = {
              competitor: key,
              overnights: overnights,
              overnigthsBef: overnightsPrev,
              evolution: overnightsEvo,
            };
            competitors.push(content);

            // add values for chart
            citiesGraphLabels.push(key);
            citiesGraphValues.push(overnightsEvo);
          }

          this.competitors_table = competitors;
          this.swissCities.data[0].data = citiesGraphValues;
          this.swissCities.options.xaxis.categories = citiesGraphLabels;
        });
    },
    getMarketsDetails() {
      axios
        .post("hesta/GetMarketsDetails", {
          monthMin: this.params.monthrange[0],
          monthMax: this.params.monthrange[1],
          regions: this.params.region.map((r) => r.value),
          language: this.$i18n.locale,
          comparisonYear: this.params.comparisonYear,
        })
        .then((res) => {
          this.marketsTable.data = res.data;
        });
    },
    getFactsheetsData() {
      axios
        .post("hesta/GetFactsheetData", {
          year: this.params.year,
          yearCompare: this.params.yearCompare,
          region: this.params.region.map((r) => r.value),
          regionCompare: this.params.regionCompare.map((r) => r.value),
          fsmarket: this.params.markets.Value,
          fsmarketCompare: this.params.marketsCompare.Value,
          compare: this.params.comparison,
        })
        .then((res) => {
          // variables
          let database = res.data.base;
          let datacomparison = res.data.comparison;
          let legend = new Array();
          let monthlyBase = new Array();
          let monthlyCumulBase = new Array();
          let monthlyCompare = new Array();
          let monthlyCumulCompare = new Array();
          let cumulBase = 0;
          let cumulCompare = 0;
          let data = new Array();
          let yaxis = new Array();

          // data definition
          switch (this.params.indicator) {
            case "overnights":
            default:
              data.push({
                name: this.$t("legends.overnights"),
                type: "column",
                data: null,
              });
              data.push({
                name: this.$t("legends.cumul_overnights"),
                type: "line",
                data: null,
              });
              if (this.params.comparison) {
                data.push({
                  name:
                    this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.overnights"),
                  type: "column",
                  data: null,
                });
                data.push({
                  name:
                    this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.cumul_overnights"),
                  type: "line",
                  data: null,
                });
              }
              break;
            case "arrivals":
              data.push({
                name: this.$t("legends.arrivals"),
                type: "column",
                data: null,
              });
              data.push({
                name: this.$t("legends.cumul_arrivals"),
                type: "line",
                data: null,
              });
              if (this.params.comparison) {
                data.push({
                  name:
                    this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.arrivals"),
                  type: "column",
                  data: null,
                });
                data.push({
                  name:
                    this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.cumul_arrivals"),
                  type: "line",
                  data: null,
                });
              }
              break;
            case "stay":
              data.push({
                name: this.$t("legends.avgStay"),
                type: "column",
                data: null,
              });
              data.push({
                name: this.$t("legends.average_avgStay"),
                type: "line",
                data: null,
              });
              if (this.params.comparison) {
                data.push({
                  name:
                    this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.avgStay"),
                  type: "column",
                  data: null,
                });
                data.push({
                  name:
                    this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.average_avgStay"),
                  type: "line",
                  data: null,
                });
              }
              break;
            case "etabs":
              data.push({
                name: this.$t("legends.etabs"),
                type: "column",
                data: null,
              });
              data.push({
                name: this.$t("legends.average_etabs"),
                type: "line",
                data: null,
              });
              if (this.params.comparison) {
                data.push({
                  name:
                    this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.etabs"),
                  type: "column",
                  data: null,
                });
                data.push({
                  name:
                    this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.average_etabs"),
                  type: "line",
                  data: null,
                });
              }
              break;
            case "rooms":
              data.push({
                name: this.$t("legends.rooms"),
                type: "column",
                data: null,
              });
              data.push({
                name: this.$t("legends.average_rooms"),
                type: "line",
                data: null,
              });
              if (this.params.comparison) {
                data.push({
                  name:
                    this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.rooms"),
                  type: "column",
                  data: null,
                });
                data.push({
                  name:
                    this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.average_rooms"),
                  type: "line",
                  data: null,
                });
              }
              break;
            case "beds":
              data.push({
                name: this.$t("legends.beds"),
                type: "column",
                data: null,
              });
              data.push({
                name: this.$t("legends.average_beds"),
                type: "line",
                data: null,
              });
              if (this.params.comparison) {
                data.push({
                  name:
                    this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.beds"),
                  type: "column",
                  data: null,
                });
                data.push({
                  name:
                    this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.average_beds"),
                  type: "line",
                  data: null,
                });
              }
              break;
          }
          this.factsheetChart.data = data;

          // yaxis definition
          switch (this.params.indicator) {
            case "overnights":
            default:
              yaxis.push({
                seriesName: this.$t("legends.overnights"),
                title: {
                  text: this.$t("legends.overnights"),
                },
                labels: {
                  formatter: function(value) {
                    return value > 0
                      ? value.toLocaleString("fr-CH", {
                          maximumFractionDigits: 2,
                          miniumFractionDigits: 0,
                        })
                      : 0;
                  },
                },
              });
              yaxis.push({
                seriesName: this.$t("legends.cumul_overnights"),
                opposite: true,
                title: {
                  text: this.$t("legends.cumul_overnights"),
                },
                labels: {
                  formatter: function(value) {
                    return value > 0
                      ? value.toLocaleString("fr-CH", {
                          maximumFractionDigits: 2,
                          miniumFractionDigits: 0,
                        })
                      : 0;
                  },
                },
              });
              break;

            case "arrivals":
              yaxis.push({
                seriesName: this.$t("legends.arrivals"),
                title: {
                  text: this.$t("legends.arrivals"),
                },
                labels: {
                  formatter: function(value) {
                    return value > 0
                      ? value.toLocaleString("fr-CH", {
                          maximumFractionDigits: 2,
                          miniumFractionDigits: 0,
                        })
                      : 0;
                  },
                },
              });
              yaxis.push({
                seriesName: this.$t("legends.cumul_arrivals"),
                opposite: true,
                title: {
                  text: this.$t("legends.cumul_arrivals"),
                },
                labels: {
                  formatter: function(value) {
                    return value > 0
                      ? value.toLocaleString("fr-CH", {
                          maximumFractionDigits: 2,
                          miniumFractionDigits: 0,
                        })
                      : 0;
                  },
                },
              });

              break;
            case "stay":
              yaxis.push({
                seriesName: this.$t("legends.avgStay"),
                title: {
                  text: this.$t("legends.avgStay"),
                },
                labels: {
                  formatter: function(value) {
                    return value > 0
                      ? value.toLocaleString("fr-CH", {
                          maximumFractionDigits: 2,
                          miniumFractionDigits: 0,
                        })
                      : 0;
                  },
                },
              });
              break;
            case "etabs":
              yaxis.push({
                seriesName: this.$t("legends.etabs"),
                title: {
                  text: this.$t("legends.etabs"),
                },
                labels: {
                  formatter: function(value) {
                    return value > 0
                      ? value.toLocaleString("fr-CH", {
                          maximumFractionDigits: 2,
                          miniumFractionDigits: 0,
                        })
                      : 0;
                  },
                },
              });
              break;
            case "rooms":
              yaxis.push({
                seriesName: this.$t("legends.rooms"),
                title: {
                  text: this.$t("legends.rooms"),
                },
                labels: {
                  formatter: function(value) {
                    return value > 0
                      ? value.toLocaleString("fr-CH", {
                          maximumFractionDigits: 2,
                          miniumFractionDigits: 0,
                        })
                      : 0;
                  },
                },
              });
              break;
            case "beds":
              yaxis.push({
                seriesName: this.$t("legends.beds"),
                title: {
                  text: this.$t("legends.beds"),
                },
                labels: {
                  formatter: function(value) {
                    return value > 0
                      ? value.toLocaleString("fr-CH", {
                          maximumFractionDigits: 2,
                          miniumFractionDigits: 0,
                        })
                      : 0;
                  },
                },
              });
              break;
          }
          this.factsheetChart.options.yaxis = yaxis;

          // base data
          database.forEach((line) => {
            // add legend
            legend.push(this.$t("el.datepicker.month" + line.month));

            // manage data based on indicator
            switch (this.params.indicator) {
              case "overnights":
              default:
                cumulBase += line.overnights;
                monthlyCumulBase.push(cumulBase);
                monthlyBase.push(line.overnights);
                break;
              case "arrivals":
                cumulBase += line.arrivals;
                monthlyCumulBase.push(cumulBase);
                monthlyBase.push(line.arrivals);
                break;
              case "stay":
                // compute sum for average
                var sum = 0;
                database.forEach((val) => {
                  sum += val.overnights / val.arrivals;
                });
                cumulBase = sum / database.length;
                monthlyCumulBase.push(cumulBase);
                monthlyBase.push(line.overnights / line.arrivals);
                break;
              case "etabs":
                // compute sum for average
                var sum = 0;
                database.forEach((val) => {
                  sum += val.etabs;
                });
                cumulBase = sum / database.length;
                monthlyCumulBase.push(cumulBase);
                monthlyBase.push(line.etabs);
                break;
              case "rooms":
                // compute sum for average
                var sum = 0;
                database.forEach((val) => {
                  sum += val.rooms;
                });
                cumulBase = sum / database.length;
                monthlyCumulBase.push(cumulBase);
                monthlyBase.push(line.rooms);
                break;
              case "beds":
                // compute sum for average
                var sum = 0;
                database.forEach((val) => {
                  sum += val.beds;
                });
                cumulBase = sum / database.length;
                monthlyCumulBase.push(cumulBase);
                monthlyBase.push(line.beds);
                break;
            }
          });

          // pass data to chart
          this.factsheetChart.data[0].data = monthlyBase;
          this.factsheetChart.data[1].data = monthlyCumulBase;

          // comparison data
          if (this.params.comparison) {
            datacomparison.forEach((comp) => {
              // add legend
              if (
                !legend.includes(this.$t("el.datepicker.month" + comp.month))
              ) {
                legend.push(this.$t("el.datepicker.month" + comp.month));
              }

              // manage data based on indicator
              switch (this.params.indicator) {
                case "overnights":
                default:
                  cumulCompare += comp.overnights;
                  monthlyCumulCompare.push(cumulCompare);
                  monthlyCompare.push(comp.overnights);
                  break;
                case "arrivals":
                  cumulCompare += comp.arrivals;
                  monthlyCumulCompare.push(cumulCompare);
                  monthlyCompare.push(comp.arrivals);
                  break;
                case "stay":
                  // compute sum for average
                  var sum = 0;
                  datacomparison.forEach((val) => {
                    sum += val.overnights / val.arrivals;
                  });
                  cumulCompare = sum / datacomparison.length;
                  monthlyCumulCompare.push(cumulCompare);
                  monthlyCompare.push(comp.overnights / comp.arrivals);
                  break;
                case "etabs":
                  // compute sum for average
                  var sum = 0;
                  datacomparison.forEach((val) => {
                    sum += val.etabs;
                  });
                  cumulCompare = sum / datacomparison.length;
                  monthlyCumulCompare.push(cumulCompare);
                  monthlyCompare.push(comp.etabs);
                  break;
                case "rooms":
                  // compute sum for average
                  var sum = 0;
                  datacomparison.forEach((val) => {
                    sum += val.rooms;
                  });
                  cumulCompare = sum / datacomparison.length;
                  monthlyCumulCompare.push(cumulCompare);
                  monthlyCompare.push(comp.rooms);
                  break;
                case "beds":
                  // compute sum for average
                  var sum = 0;
                  datacomparison.forEach((val) => {
                    sum += val.beds;
                  });
                  cumulCompare = sum / datacomparison.length;
                  monthlyCumulCompare.push(cumulCompare);
                  monthlyCompare.push(comp.beds);
                  break;
              }
            });

            this.factsheetChart.data[2].data = monthlyCompare;
            this.factsheetChart.data[3].data = monthlyCumulCompare;
          }

          this.factsheetChart.options.xaxis.categories = legend;
        });
    },
    getFactsheetsGData() {
      axios
        .post("hesta/GetFactsheetData", {
          year: this.params.year,
          yearCompare: this.params.yearCompare,
          region: this.params.region.map((r) => r.value),
          regionCompare: this.params.regionCompare.map((r) => r.value),
          fsmarket: this.params.markets.Value,
          fsmarketCompare: this.params.marketsCompare.Value,
          compare: this.params.comparison,
        })
        .then((res) => {
          // empty arrays
          var basedata = res.data.base;
          var comparisondata = res.data.comparison;
          var data = [
            ["monat"],
            [this.$t("el.datepicker.month1")],
            [this.$t("el.datepicker.month2")],
            [this.$t("el.datepicker.month3")],
            [this.$t("el.datepicker.month4")],
            [this.$t("el.datepicker.month5")],
            [this.$t("el.datepicker.month6")],
            [this.$t("el.datepicker.month7")],
            [this.$t("el.datepicker.month8")],
            [this.$t("el.datepicker.month9")],
            [this.$t("el.datepicker.month10")],
            [this.$t("el.datepicker.month11")],
            [this.$t("el.datepicker.month12")],
          ];
          var baseCumul = 0;
          var comparisonCumul = 0;
          var position = 0;

          if (this.params.comparison) {
            var length =
              basedata.length > comparisondata.length
                ? basedata.base.length
                : comparisondata.length;
            // labels
            switch (this.params.indicator) {
              case "overnights":
              default:
                this.gchart.options.series[1].targetAxisIndex = 1;
                this.gchart.options.series[3].targetAxisIndex = 1;
                data[0].push(this.$t("legends.overnights"));
                data[0].push(this.$t("legends.cumul_overnights"));
                data[0].push(
                  this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.overnights")
                );
                data[0].push(
                  this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.cumul_overnights")
                );
                break;
              case "arrivals":
                this.gchart.options.series[1].targetAxisIndex = 1;
                this.gchart.options.series[3].targetAxisIndex = 1;
                data[0].push(this.$t("legends.arrivals"));
                data[0].push(this.$t("legends.cumul_arrivals"));
                data[0].push(
                  this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.arrivals")
                );
                data[0].push(
                  this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.cumul_arrivals")
                );
                break;
              case "stay":
                this.gchart.options.series[1].targetAxisIndex = 0;
                this.gchart.options.series[3].targetAxisIndex = 0;
                data[0].push(this.$t("legends.avgStay"));
                data[0].push(this.$t("legends.average_avgStay"));
                data[0].push(
                  this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.avgStay")
                );
                data[0].push(
                  this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.average_avgStay")
                );
                break;
              case "etabs":
                this.gchart.options.series[1].targetAxisIndex = 0;
                this.gchart.options.series[3].targetAxisIndex = 0;
                data[0].push(this.$t("legends.etabs"));
                data[0].push(this.$t("legends.average_etabs"));
                data[0].push(
                  this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.etabs")
                );
                data[0].push(
                  this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.average_etabs")
                );
                break;
              case "rooms":
                this.gchart.options.series[1].targetAxisIndex = 0;
                this.gchart.options.series[3].targetAxisIndex = 0;
                data[0].push(this.$t("legends.rooms"));
                data[0].push(this.$t("legends.average_rooms"));
                data[0].push(
                  this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.rooms")
                );
                data[0].push(
                  this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.average_rooms")
                );
                break;
              case "beds":
                this.gchart.options.series[1].targetAxisIndex = 0;
                this.gchart.options.series[3].targetAxisIndex = 0;
                data[0].push(this.$t("legends.beds"));
                data[0].push(this.$t("legends.average_beds"));
                data[0].push(
                  this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.beds")
                );
                data[0].push(
                  this.$t("legends.comparison") +
                    " - " +
                    this.$t("legends.average_beds")
                );
                break;
            }

            // do something
            for (var pos = 0; pos < length; pos++) {
              position = pos + 1;
              switch (this.params.indicator) {
                case "overnights":
                default:
                  if (basedata[pos]) {
                    baseCumul += basedata[pos].overnights;
                    data[position].push(basedata[pos].overnights);
                    data[position].push(baseCumul);
                  } else {
                    data[position].push(null);
                    data[position].push(null);
                  }

                  if (comparisondata[pos]) {
                    comparisonCumul += comparisondata[pos].overnights;
                    data[position].push(comparisondata[pos].overnights);
                    data[position].push(comparisonCumul);
                  } else {
                    data[position].push(null);
                    data[position].push(null);
                  }

                  break;
                case "arrivals":
                  if (basedata[pos]) {
                    data[position].push(basedata[pos].arrivals);
                    baseCumul += basedata[pos].arrivals;
                    data[position].push(baseCumul);
                  } else {
                    data[position].push(null);
                    data[position].push(null);
                  }

                  if (comparisondata[pos]) {
                    comparisonCumul += comparisondata[pos].arrivals;
                    data[position].push(comparisondata[pos].arrivals);
                    data[position].push(comparisonCumul);
                  } else {
                    data[position].push(null);
                    data[position].push(null);
                  }
                  break;
                case "stay":
                  if (basedata[pos]) {
                    data[position].push(
                      basedata[pos].overnights / basedata[pos].arrivals
                    );
                    // compute sum for average
                    var sum = 0;
                    basedata.forEach((val) => {
                      sum += val.overnights / val.arrivals;
                    });
                    baseCumul = sum / basedata.length;
                    data[position].push(baseCumul);
                  } else {
                    data[position].push(null);
                    data[position].push(null);
                  }

                  if (comparisondata[pos]) {
                    data[position].push(
                      comparisondata[pos].overnights /
                        comparisondata[pos].arrivals
                    );
                    // compute sum for average
                    var sum = 0;
                    comparisondata.forEach((val) => {
                      sum += val.overnights / val.arrivals;
                    });
                    comparisonCumul = sum / comparisondata.length;
                    data[position].push(comparisonCumul);
                  } else {
                    data[position].push(null);
                    data[position].push(null);
                  }
                  break;
                case "etabs":
                  if (basedata[pos]) {
                    data[position].push(basedata[pos].etabs);
                    // compute sum for average
                    var sum = 0;
                    basedata.forEach((val) => {
                      sum += val.etabs;
                    });
                    baseCumul = sum / basedata.length;
                    data[position].push(baseCumul);
                  } else {
                    data[position].push(null);
                    data[position].push(null);
                  }

                  if (comparisondata[pos]) {
                    data[position].push(comparisondata[pos].etabs);
                    // compute sum for average
                    var sum = 0;
                    comparisondata.forEach((val) => {
                      sum += val.etabs;
                    });
                    comparisonCumul = sum / comparisondata.length;
                    data[position].push(comparisonCumul);
                  } else {
                    data[position].push(null);
                    data[position].push(null);
                  }
                  break;
                case "rooms":
                  if (basedata[pos]) {
                    data[position].push(basedata[pos].rooms);
                    // compute sum for average
                    var sum = 0;
                    basedata.forEach((val) => {
                      sum += val.rooms;
                    });
                    baseCumul = sum / basedata.length;
                    data[position].push(baseCumul);
                  } else {
                    data[position].push(null);
                    data[position].push(null);
                  }

                  if (comparisondata[pos]) {
                    data[position].push(comparisondata[pos].rooms);
                    // compute sum for average
                    var sum = 0;
                    comparisondata.forEach((val) => {
                      sum += val.rooms;
                    });
                    comparisonCumul = sum / comparisondata.length;
                    data[position].push(comparisonCumul);
                  } else {
                    data[position].push(null);
                    data[position].push(null);
                  }
                  break;
                case "beds":
                  if (basedata[pos]) {
                    data[position].push(basedata[pos].beds);
                    // compute sum for average
                    var sum = 0;
                    basedata.forEach((val) => {
                      sum += val.beds;
                    });
                    baseCumul = sum / basedata.length;
                    data[position].push(baseCumul);
                  } else {
                    data[position].push(null);
                    data[position].push(null);
                  }

                  if (comparisondata[pos]) {
                    data[position].push(comparisondata[pos].beds);
                    // compute sum for average
                    var sum = 0;
                    comparisondata.forEach((val) => {
                      sum += val.beds;
                    });
                    comparisonCumul = sum / comparisondata.length;
                    data[position].push(comparisonCumul);
                  } else {
                    data[position].push(null);
                    data[position].push(null);
                  }
                  break;
              }
            }
            // increment in order to go to next month
            position += 1;
            while (position <= 12) {
              data[position].push(null);
              data[position].push(null);
              data[position].push(null);
              data[position].push(null);
              position += 1;
            }
          } else {
            // labels
            switch (this.params.indicator) {
              case "overnights":
              default:
                this.gchart.options.series[1].targetAxisIndex = 1;
                data[0].push(this.$t("legends.overnights"));
                data[0].push(this.$t("legends.cumul_overnights"));
                break;
              case "arrivals":
                this.gchart.options.series[1].targetAxisIndex = 1;
                data[0].push(this.$t("legends.arrivals"));
                data[0].push(this.$t("legends.cumul_arrivals"));
                break;
              case "stay":
                this.gchart.options.series[1].targetAxisIndex = 0;
                data[0].push(this.$t("legends.avgStay"));
                data[0].push(this.$t("legends.average_avgStay"));
                break;
              case "etabs":
                this.gchart.options.series[1].targetAxisIndex = 0;
                data[0].push(this.$t("legends.etabs"));
                data[0].push(this.$t("legends.average_etabs"));
                break;
              case "rooms":
                this.gchart.options.series[1].targetAxisIndex = 0;
                data[0].push(this.$t("legends.rooms"));
                data[0].push(this.$t("legends.average_rooms"));
                break;
              case "beds":
                this.gchart.options.series[1].targetAxisIndex = 0;
                data[0].push(this.$t("legends.beds"));
                data[0].push(this.$t("legends.average_beds"));
                break;
            }

            // do something
            basedata.forEach((line) => {
              position = line.month + 1;
              switch (this.params.indicator) {
                case "overnights":
                default:
                  baseCumul += line.overnights;
                  data[line.month].push(line.overnights);
                  data[line.month].push(baseCumul);
                  break;
                case "arrivals":
                  data[line.month].push(line.arrivals);
                  baseCumul += line.arrivals;
                  data[line.month].push(baseCumul);
                  break;
                case "stay":
                  data[line.month].push(line.overnights / line.arrivals);
                  // compute sum for average
                  var sum = 0;
                  basedata.forEach((val) => {
                    sum += val.overnights / val.arrivals;
                  });
                  baseCumul = sum / basedata.length;
                  data[line.month].push(baseCumul);
                  break;
                case "etabs":
                  data[line.month].push(line.etabs);
                  // compute sum for average
                  var sum = 0;
                  basedata.forEach((val) => {
                    sum += val.etabs;
                  });
                  baseCumul = sum / basedata.length;
                  data[line.month].push(baseCumul);
                  break;
                case "rooms":
                  data[line.month].push(line.rooms);
                  // compute sum for average
                  var sum = 0;
                  basedata.forEach((val) => {
                    sum += val.rooms;
                  });
                  baseCumul = sum / basedata.length;
                  data[line.month].push(baseCumul);
                  break;
                case "beds":
                  data[line.month].push(line.beds);
                  // compute sum for average
                  var sum = 0;
                  basedata.forEach((val) => {
                    sum += val.beds;
                  });
                  baseCumul = sum / basedata.length;
                  data[line.month].push(baseCumul);
                  break;
              }
            });

            while (position <= 12) {
              data[position].push(null);
              data[position].push(null);
              position += 1;
            }
          }

          this.gchart.data = data;
        });
    },
    getCompetitorsFullTable() {
      axios
        .post("hesta/GetCompetitorsTable", {
          monthMin: this.params.monthrange[0],
          monthMax: this.params.monthrange[1],
          regions: [101], // force param for Zürich city
          language: this.$i18n.locale,
          fsmarket: this.params.markets.Value,
          comparisonYear: this.params.comparisonYear,
        })
        .then((res) => {
          var table = new Array();

          for (var key in res.data) {
            var content = {
              competitor: key,
              overnights:
                res.data[key].overnights == -1
                  ? this.$t("general.dataProtection")
                  : res.data[key].overnights,
              overnigthsBef:
                res.data[key].overnightsPrev == -1
                  ? this.$t("general.dataProtection")
                  : res.data[key].overnights,
              arrivals:
                res.data[key].overnights == -1
                  ? this.$t("general.dataProtection")
                  : res.data[key].arrivals,
              lOfStay:
                res.data[key].overnights == -1
                  ? this.$t("general.dataProtection")
                  : res.data[key].lOfStay.toLocaleString("fr-CH", {
                      maximumFractionDigits: 2,
                    }),
              evolution:
                res.data[key].overnights == -1
                  ? this.$t("general.dataProtection")
                  : (res.data[key].overnightsPrev > 0
                      ? res.data[key].overnights /
                          res.data[key].overnightsPrev -
                        1
                      : 1
                    ).toLocaleString("fr-CH", {
                      style: "percent",
                      maximumFractionDigits: 2,
                    }),
              evolution_real:
                res.data[key].overnights == -1
                  ? this.$t("general.dataProtection")
                  : (res.data[key].overnightsPrev > 0
                      ? res.data[key].overnights - res.data[key].overnightsPrev
                      : 1
                    ).toLocaleString("fr-CH"),
              occupation:
                res.data[key].overnights == -1
                  ? this.$t("general.dataProtection")
                  : res.data[key].occupation,
            };

            table.push(content);
          }

          this.recapTable.data = table;
        });
    },
    getCompetitorsProvenances() {
      axios
        .post(
          "hesta/GetBenchmarkProvenances",
          {
            monthMin: this.params.monthrange[0],
            monthMax: this.params.monthrange[1],
            regions: [101],
            fsmarket: this.params.markets.Value,
            comparisonPeriod: this.params.comparisonPeriod,
            language: this.$i18n.locale,
            competitor_id: this.params.competitor ? this.params.competitor : 0,
          },
          { headers: { Authorization: `Bearer ${this.token}` } }
        )
        .then((res) => {
          // compute provenances
          var data = res.data.provenances;
          var items = [];
          var main_markets = [];
          var position = 0;

          data.forEach(function(item) {
            var content = {
              market: item.country,
              overnights:
                item.overnights != -1
                  ? item.overnights > 0
                    ? item.overnights.toLocaleString("fr-CH")
                    : 0
                  : this.$t("general.dataProtection"),
              evolution_num:
                item.overnights >= 0
                  ? item.overnights > 0 && item.overnigthsBef > 0
                    ? item.overnights / item.overnigthsBef - 1
                    : item.overnights > 0
                    ? Infinity
                    : -1
                  : this.$t("general.dataProtection"),
              evolution:
                item.overnights >= 0
                  ? item.overnights > 0 && item.overnigthsBef > 0
                    ? (item.overnights / item.overnigthsBef - 1).toLocaleString(
                        "fr-CH",
                        {
                          style: "percent",
                          maximumFractionDigits: 2,
                        }
                      )
                    : (item.overnights > 0 ? Infinity : -1).toLocaleString(
                        "fr-CH",
                        {
                          style: "percent",
                          maximumFractionDigits: 2,
                        }
                      )
                  : this.$t("general.dataProtection"),
              evolution_real:
                item.overnights >= 0
                  ? (item.overnights - item.overnigthsBef).toLocaleString(
                      "fr-CH"
                    )
                  : this.$t("general.dataProtection"),
              evolution_real_num:
                item.overnights >= 0
                  ? item.overnights - item.overnigthsBef
                  : this.$t("general.dataProtection"),
              marketShare:
                item.overnights >= 0
                  ? item.marketShare > 0
                    ? item.marketShare.toLocaleString("fr-CH", {
                        style: "percent",
                        maximumFractionDigits: 2,
                      })
                    : ""
                  : this.$t("general.dataProtection"),
              benchOvernights:
                item.overnights >= 0
                  ? item.benchOvernights > 0
                    ? item.benchOvernights.toLocaleString("fr-CH")
                    : 0
                  : this.$t("general.dataProtection"),
              benchEvolution_num:
                item.overnights >= 0
                  ? item.benchOvernights > 0 && item.benchOvernightsBef > 0
                    ? item.benchOvernights / item.benchOvernightsBef - 1
                    : item.benchOvernights > 0
                    ? Infinity
                    : -1
                  : this.$t("general.dataProtection"),
              benchEvolution:
                item.overnights >= 0
                  ? item.benchOvernights > 0 && item.benchOvernightsBef > 0
                    ? (
                        item.benchOvernights / item.benchOvernightsBef -
                        1
                      ).toLocaleString("fr-CH", {
                        style: "percent",
                        maximumFractionDigits: 2,
                      })
                    : (item.benchOvernights > 0 ? Infinity : -1).toLocaleString(
                        "fr-CH",
                        {
                          style: "percent",
                          maximumFractionDigits: 2,
                        }
                      )
                  : this.$t("general.dataProtection"),
              benchEvolution_real:
                item.overnights >= 0
                  ? (
                      item.benchOvernights - item.benchOvernightsBef
                    ).toLocaleString("fr-CH")
                  : this.$t("general.dataProtection"),
              benchEvolution_real_num:
                item.overnights >= 0
                  ? item.benchOvernights - item.benchOvernightsBef
                  : this.$t("general.dataProtection"),
              benchMarketShare:
                item.overnights >= 0
                  ? item.benchMarketShare > 0
                    ? item.benchMarketShare.toLocaleString("fr-CH", {
                        style: "percent",
                        maximumFractionDigits: 2,
                      })
                    : ""
                  : this.$t("general.dataProtection"),
            };

            items.push(content);

            if (position < 10) {
              main_markets.push(content);
              position += 1;
            }
          });
          this.provenanceCard.content = items;
        });
    },
    async loadCompetitors() {
      await axios
        .post("hesta/getTouristicSpotCompetitors", {
          regions: [101],
          language: this.$i18n.locale,
        })
        .then((res) => {
          this.options = [
            { text: this.$t("filter.competitors.allCompetitors"), value: 0 },
          ].concat(res.data);
        });
    },
    async getEvo12Months(competitor) {
      await axios
        .post(
          "hesta/last12Months",
          {
            monthMin: this.params.monthrange[0],
            monthMax: this.params.monthrange[1],
            regions: [101],
            fsmarket: this.params.markets.Value,
            comparisonPeriod: this.params.comparisonPeriod,
            language: this.$i18n.locale,
            competitor_id: competitor,
          },
          { headers: { Authorization: `Bearer ${this.token}` } }
        )
        .then((res) => {
          var data = res.data.destination;

          //this.evolutionChart.data = data;
          var legend = new Array();
          var serieAct = new Array();
          var seriePrev = new Array();
          var serieEvo = new Array();

          data.forEach(function(item) {
            legend.push(item.month + "." + item.year);
            serieAct.push(item.overnights);
            seriePrev.push(item.overnightsBef);
            serieEvo.push(
              parseFloat(item.overnights) / parseFloat(item.overnightsBef) - 1
            );
          });

          this.evolutionChart.options.xaxis.categories = legend;
          this.evolutionChart.data[0].data = serieAct;
          this.evolutionChart.data[1].data = seriePrev;
          this.overYearChart.options.xaxis.categories = legend;
          this.overYearChart.data[0].data = serieEvo;

          // check if benchmark
          if (competitor >= 0) {
            var benchmarkData = res.data.benchmark;

            var competitorAct = new Array();
            var competitorPrev = new Array();
            var competitorEvo = new Array();

            benchmarkData.forEach(function(item) {
              competitorAct.push(item.overnights);
              competitorPrev.push(item.overnightsBef);
              competitorEvo.push(
                parseFloat(item.overnights) / parseFloat(item.overnightsBef) - 1
              );
            });

            this.evolutionChart.data[2].data = competitorAct;
            this.overYearChart.data[1].data = competitorEvo;
          }
        });
    },
  },
  computed: {
    ...mapGetters("regions", ["regions"]),
    ...mapGetters("markets", ["markets"]),
  },
};
